import { defineMessages } from 'react-intl';

export default defineMessages({
  expand: { defaultMessage: 'Expand' },
  minimize: { defaultMessage: 'Minimize' },
});
